module.exports = __webpack_public_path__ + "img/1656743361000.cf412bfd.png";